var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStripe = function SvgStripe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 33,
    viewBox: "0 0 80 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7783 17.0436C79.7783 11.4783 77.0379 7.08704 71.8004 7.08704C66.5407 7.08704 63.3584 11.4783 63.3584 17.0001C63.3584 23.5436 67.1153 26.8479 72.5076 26.8479C75.1374 26.8479 77.1263 26.261 78.6291 25.4349V21.087C77.1263 21.8262 75.4026 22.2827 73.2147 22.2827C71.0711 22.2827 69.1705 21.5436 68.9275 18.9783H79.7341C79.7341 18.6957 79.7783 17.5653 79.7783 17.0436ZM68.8612 14.9783C68.8612 12.5218 70.386 11.5001 71.7783 11.5001C73.1263 11.5001 74.5628 12.5218 74.5628 14.9783H68.8612Z",
    fill: "#6772E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8283 7.08704C52.6626 7.08704 51.2703 8.08704 50.4968 8.78269L50.2095 7.43486H45.3477V32.7827L50.8725 31.6305L50.8946 25.4783C51.6902 26.0436 52.8615 26.8479 54.8062 26.8479C58.762 26.8479 62.3642 23.7175 62.3642 16.8262C62.3421 10.5218 58.6957 7.08704 54.8283 7.08704ZM53.5024 22.0653C52.1985 22.0653 51.425 21.6088 50.8946 21.0436L50.8725 12.9783C51.4471 12.3479 52.2427 11.9131 53.5024 11.9131C55.5134 11.9131 56.9057 14.1305 56.9057 16.9783C56.9057 19.8914 55.5355 22.0653 53.5024 22.0653Z",
    fill: "#6772E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2921 4.63045V0.217407L37.7451 1.36958V5.80436L43.2921 4.63045Z",
    fill: "#6772E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2921 7.45654H37.7451V26.4783H43.2921V7.45654Z",
    fill: "#6772E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8009 9.06521L31.4473 7.45652H26.6738V26.4783H32.1987V13.587C33.5026 11.913 35.7125 12.2174 36.3976 12.4565V7.45652C35.6904 7.19565 33.1048 6.71739 31.8009 9.06521Z",
    fill: "#6772E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7513 2.73914L15.359 3.86957L15.3369 21.2826C15.3369 24.5 17.79 26.8696 21.0607 26.8696C22.8728 26.8696 24.1988 26.5435 24.9281 26.1522V21.7391C24.2209 22.0217 20.7292 23.0217 20.7292 19.8044V12.087H24.9281V7.45653H20.7292L20.7513 2.73914Z",
    fill: "#6772E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81186 12.9783C5.81186 12.1305 6.51905 11.8044 7.69032 11.8044C9.36988 11.8044 11.4914 12.3044 13.171 13.1957V8.08704C11.3367 7.36964 9.52457 7.08704 7.69032 7.08704C3.20413 7.08704 0.220703 9.39138 0.220703 13.2392C0.220703 19.2392 8.61849 18.2827 8.61849 20.8696C8.61849 21.8696 7.73452 22.1957 6.49695 22.1957C4.66269 22.1957 2.32015 21.4566 0.463797 20.4566V25.6305C2.51905 26.5001 4.59639 26.8696 6.49695 26.8696C11.0936 26.8696 14.2539 24.6305 14.2539 20.7392C14.2318 14.2609 5.81186 15.4131 5.81186 12.9783Z",
    fill: "#6772E5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStripe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stripe.d5961989.svg";
export { ForwardRef as ReactComponent };